import { SubjectSpec } from "@atgof-common/subject";
import { useNavigation } from "@react-navigation/core";
import { Button } from "react-native-paper";

export function SubjectButton({
  episodePath,
  fallback,
  ...subjectSpec
}: {
  episodePath: string | undefined;
  fallback?: React.ReactElement;
} & SubjectSpec) {
  const { navigate } = useNavigation();
  if (!episodePath) return fallback ?? null;
  return (
    <Button
      onPress={() =>
        navigate("episodeBreakdown", {
          path: episodePath,
          ...subjectSpec,
        })
      }
    >
      {subjectSpec.subjectName}
    </Button>
  );
}
